import {
  whiteHard,
  grayHard,
  whiteLight,
  grayMedium,
} from 'styleVars/getColors';

export const styles = (theme) => ({
  root: {
    boxShadow: 'none',
    '&:before': {
      opacity: '1 !important',
    },
  },
  rootTop: {
    boxShadow: 'none',
  },
  expanded: {
    margin: '0 !important',
    '&:last-child': {
      marginBottom: '30px',
    },
  },
  arrow: {
    color: theme.palette.primary.main,
    fontSize: '26px',
    fontFamily: '"Open Sans", sans-serif',
  },
  icon: {
    left: 'auto',
    right: '8px',
  },
  iconRtl: {
    left: '8px',
    right: 'auto',
  },
  header: {
    minHeight: '60px !important',
    color: theme.palette.primary.main,
    fontSize: '18px',
    fontWeight: 700,
    fontFamily: '"Open Sans", sans-serif',
    padding: '0 20px',
    justifyContent: 'space-between',

    '&>div:first-child': {
      margin: '0 !important',
      paddingInlineStart: '4px',
      flexGrow: 0,
    },
  },
  hasTabs: { paddingInlineStart: 0 },
  details: {
    padding: 0,
  },
  disabled: {
    background: whiteHard,
    color: grayHard,
  },
  disabledHeader: {
    background: grayMedium,
    color: whiteLight,
    opacity: '1 !important',
  },
});
